/* eslint-disable max-len */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { sortBy } from 'lodash'
import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import { compile } from '../../../utils/search'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'

interface Category {
  id: number
  category_name: string
  color: string
  parent_id: number | null
}

interface Props {
  categoryList: Category[]
  selectCategoryIdList: number[]
  callback: (categoryIds: number[]) => void
  createCategoryCallback: () => void
  isRealTime?: boolean
}

const AddCategoryModule: FC<Props> = (props) => {
  const {
    categoryList,
    selectCategoryIdList,
    callback,
    createCategoryCallback,
    isRealTime,
  } = props

  const {
    login,
  } = useSelector((state: RootState) => state)

  const modalRef = useRef<HTMLDivElement>(null)
  const [isSearchDisplay, setIsSearchDisplay] = useState(false)
  const [selectCategories, setSelectCategories] = useState<Category[]>([])
  const [categories, setCategories] = useState<Category[]>([])
  const [searchCategoryWord, setSearchCategoryWord] = useState<string>("")

  const categoriesInit = useMemo(() => (
    categoryList || []
  ), [categoryList])

  const clickCategory = (categoryId: number) => {
    let tmpCategories: Category[] = []
    if (selectCategories.map((v) => v.id).includes(categoryId)) {
      tmpCategories = selectCategories.filter((v) => v.id !== categoryId)
    } else {
      const addCategory = categoryList.find((v) => v.id === categoryId)
      if (addCategory) {
        tmpCategories = [...selectCategories, addCategory]
      } else {
        tmpCategories = [...selectCategories]
      }
    }
    setSelectCategories(tmpCategories)
    if (isRealTime) callback(tmpCategories.map((v) => v.id))
  }

  const searchCategory = (words: string) => {
    setSearchCategoryWord(words)
    if (!words) {
      setCategories([...categoriesInit])
      return
    }
    const word = words.toLowerCase().split(/\s+/)
    const list = categoriesInit.filter((category) => {
      if (category === null) return false
      return compile(word).test(category.category_name.toLowerCase())
    })
    setCategories(sortBy(list, 'id'))
  }

  const resetSearchCategory = () => {
    setSearchCategoryWord("")
    setCategories([...categoriesInit])
  }

  const openSearch = () => {
    setIsSearchDisplay(true)
  }

  const closeSearch = () => {
    setIsSearchDisplay(false)
    resetSearchCategory()
    callback(selectCategories.map((v) => v.id))
  }

  const reset = () => {
    setSelectCategories([])
  }

  useEffect(() => {
    if (!selectCategoryIdList) return
    setSelectCategories(categoryList.filter((v) => selectCategoryIdList?.includes(v.id)))
  }, [categoryList, selectCategoryIdList])

  return (
    <>
      <div
        className="add_button"
        onClick={() => openSearch()}
        role="none"
        ref={modalRef}
      >
        <FontAwesomeIcon icon={['fas', 'plus']} />
        &nbsp;
        追加
        <div className={`search_box ${isSearchDisplay || 'none'}`} style={{ left: "-200px", width: "432px" }}>
          <div
            style={{
              position: "relative",
            }}
          >
            <div className="search_detail" style={{ width: "400px" }}>
              <div className="category">
                <div className="category_title">
                  カテゴリー選択
                  {
                    !!selectCategories.length && (
                      <div
                        className="select_reset"
                        role="none"
                        onClick={reset}
                      >
                        リセット
                      </div>
                    )
                  }
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    カテゴリー
                  </div>
                  {
                    login.role_permission?.task_category_setting && (
                      <button
                        type="button"
                        style={{
                          borderRadius: "4px",
                          fontSize: "10px",
                          backgroundColor: "#4472ba",
                          color: "#FFFFFF",
                        }}
                        onClick={(e) => {
                          closeSearch()
                          createCategoryCallback()
                          e.stopPropagation()
                        }}
                      >
                        新規カテゴリー作成
                      </button>
                    )
                  }
                </div>
                <div className="search_area">
                  <FontAwesomeIcon
                    icon={['fas', 'search']}
                    className="icon"
                  />
                  <input
                    type="text"
                    placeholder="カテゴリーを検索"
                    onChange={(event) => searchCategory(event.target.value)}
                    value={searchCategoryWord}
                  />
                  {
                    searchCategoryWord && (
                      <button type="button" className="reset" onClick={resetSearchCategory}>
                        <FontAwesomeIcon icon={['far', 'times-circle']} />
                      </button>
                    )
                  }
                  {
                    searchCategoryWord && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: "0",
                          border: "solid 1px #CCCCCC",
                          width: "100%",
                          maxHeight: "200px",
                          overflowY: "scroll",
                          backgroundColor: "#FFFFFF",
                          zIndex: "1221",
                          padding: "8px",
                        }}
                      >
                        {
                          categories.length ? (
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "4px",
                              }}
                            >
                              {
                                categories.map((category) => (
                                  <button
                                    type="button"
                                    className={`chip ${selectCategories.map((v) => v.id).includes(category.id) ? "checked" : ""}`}
                                    key={`category_${category.id}`}
                                    onClick={() => clickCategory(category.id)}
                                    style={{
                                      padding: "4px 8px",
                                    }}
                                  >
                                    {category.category_name}
                                  </button>
                                ))
                              }
                            </div>
                          ) : (
                            <>
                              {`「${searchCategoryWord}」に該当するカテゴリーがありませんでした`}
                            </>
                          )
                        }
                      </div>
                    )
                  }
                </div>
                <div
                  style={{
                    padding: "4px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "4px",
                  }}
                >
                  {
                    categoryList.map((category) => (
                      <button
                        type="button"
                        className={`chip ${selectCategories.map((v) => v.id).includes(category.id) ? "checked" : ""}`}
                        key={`category_${category.id}`}
                        onClick={() => clickCategory(category.id)}
                        style={{
                          padding: "4px 8px",
                          margin: 0,
                        }}
                      >
                        {category.category_name}
                      </button>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`close_screen ${isSearchDisplay || 'none'}`} role="presentation" onClick={closeSearch} />
    </>
  )
}

AddCategoryModule.defaultProps = {
  isRealTime: false,
}

export default AddCategoryModule
